// extracted by mini-css-extract-plugin
module.exports = {"spacing":"spacing_spacing__c8Ogn"};